import Item from "./item"
import classNames from "classnames"

export default function Menu({
  menuClasses,
  items,
  location,
  icon = false,
  hover = false,
  ariaLabelledby
}) {
  if (!items || items?.length === 0) {
    return null
  }

  return (
    <ul
      className={classNames([menuClasses, { "has-icon": icon }])}
      role="menu"
      aria-labelledby={ariaLabelledby}
      data-location={location}>
      {items.map((item, index) => (
        <Item
          icon={icon}
          hover={hover}
          key={location + item.url + index}
          location={location}
          item={item}
        />
      ))}
    </ul>
  )
}
